export const reactivateDcrControlStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 1,
		width: '100%'
	},

	actions: {
		display: 'flex',
		gap: 1,
		width: '100%',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},

	button: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		minWidth: 'max-content',
		height: '32px',
		fontWeight: 700,
		lineHeight: 1
	},
	title: {
		width: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		gap: 1
	},
	dcrLink: {
		textTransform: 'none',
		whiteSpace: 'nowrap',
		flexShrink: 0
	},
	body: {
		display: 'flex',
		flexDirection: 'column'
	}
};
